import { I18n } from '@calendly/i18n'

// i18n-tasks-use t('publisher.organization.invite_flow.steps.add_emails')
// i18n-tasks-use t('publisher.organization.invite_flow.steps.set_roles')
// i18n-tasks-use t('publisher.organization.invite_flow.steps.assign_event_types')
// i18n-tasks-use t('publisher.organization.invite_flow.steps.done')
export const stepName = (step) => {
  if (!step) return ''
  return I18n.t(`publisher.organization.invite_flow.steps.${step}`)
}

export const STEPS = [
  'add_emails',
  'set_roles',
  'assign_event_types',
  'done',
]
